import { Component, OnInit, ChangeDetectorRef, ViewEncapsulation } from '@angular/core';
import { LanguageAware } from '../language-aware';
import { Router } from '@angular/router';
import { EditSystemService } from 'src/app/services/edit-system.service';
import { WebSocketService } from 'src/app/services/websocket.service';
import { DateService } from 'src/app/services/date.service';
import { PopupService } from 'src/app/services/popup.service';
import { PopupType } from 'src/app/models/popup-type';
import { GoogleAuthService } from 'src/app/api/google-auth.service';
import { MessageboxService } from 'src/app/services/messagebox.service';
import { CurrentUserData, PermissionRole } from 'src/api/v3/common';
import { DropdownItem } from 'src/app/ui/dropdown/dropdown.component';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ProfileComponent extends LanguageAware implements OnInit {
  public userDataChanged = false;
  public userToUse: CurrentUserData = null;
  public dateTimeFormats: DropdownItem<number>[] = [];
  private oldSettings = {
    name: '',
    phone: '',
    format: 0,
    company: '',
  };
  public dateFormatText = '';
  public PermissionRole = PermissionRole;

  constructor(
    cdRef: ChangeDetectorRef,
    public router: Router,
    public es: EditSystemService,
    private ws: WebSocketService,
    private dt: DateService,
    private google: GoogleAuthService,
    private pp: PopupService,
    private messagebox: MessageboxService,
  ) {
    super(cdRef);
    this.tag = 'Profile';
    this.background.setGray();
    this.populateDateTimeFormats();
    if (this.myOwnProfile()) {
      this.userToUse = this.us.currentUser;
    } else {
      this.userToUse = this.es.currentUserObj;
    }
    this.headerBar.showHeader({
      headerText: this.trans('users.titles.profileHeader'),
      backUrl: es.currentUserObj === null ? this.g.getHomeUrl().join('/') : '/users',
    });
    if (this.es.currentUserObj === null) {
      this.footerBar.showFooter(this.trans('general.cancel'), this.trans('general.save'), true, false);
    }
    const that = this;
    this.oldSettings.name = this.us.currentUser.name;
    this.oldSettings.phone = this.us.currentUser.phone;
    this.oldSettings.format = this.us.currentUser.date_format;
    this.footerBar.onButton1Click = () => {
      that.revertChanges(JSON.stringify(this.oldSettings));
      that.router.navigate(this.g.getHomeUrl());
    };
    this.footerBar.onButton2Click = () => {
      let canNavigate = !that.userDataChanged;
      if (that.userDataChanged) {
        canNavigate = that.saveUserSettings();
      }
      if (canNavigate) {
        that.router.navigate(this.g.getHomeUrl());
      }
    };
    this.headerBar.onBackClicked = () => {
      if (es.currentUserObj === null) {
        that.revertChanges(JSON.stringify(this.oldSettings));
      }
    };
    let fmt = this.dateTimeFormats.find((f) => f.value === this.userToUse.date_format);
    if (fmt === undefined) {
      fmt = this.dateTimeFormats[0];
    }
    this.dateFormatText = fmt.label as string;
  }

  ngOnInit(): void {}

  public myOwnProfile(): boolean {
    return this.es.currentUserObj === null || this.es.currentUserObj.id === this.us.currentUser.id;
  }

  public doLogout() {
    this.systems.clearSystems();
    this.api.setToken('');
    this.ws.close();
    if (this.platform.isDesktop()) {
      const loginType = this.us.getLoginType();
      if (loginType !== null && loginType === 'google') {
        this.google.signOut(true);
      }
    } else if (this.platform.isAndroid()) {
      this.platform.androidHandler().doLogOutGoogle();
    }
    this.router.navigate(['/login']);
  }

  public saveUserSettings(userData?: any): boolean {
    if (!this.myOwnProfile()) {
      return false;
    }
    if (this.userToUse.name !== null || userData?.name) {
      this.userToUse.name = userData?.name ? userData.name.trim() : this.userToUse.name.trim();
    }
    if (this.userToUse.phone !== null || userData?.phone) {
      this.userToUse.phone = userData?.phone ? userData.phone.trim() : this.userToUse.phone.trim();
    }
    if (this.userToUse.phone !== null && this.userToUse.phone !== '' && !/^[0-9+\-\s]+$/.test(this.userToUse.phone)) {
      this.messagebox.open({
        buttons: this.messagebox.buttons.Close,
        headerText: this.trans('general.titleError'),
        messageContent: this.trans('validation.phoneInvalid'),
        iconType: this.messagebox.iconType.Error
      });
      return false;
    }
    this.log('laikas saugoti nustatymus.');
    const that = this;
    const old = JSON.stringify(this.oldSettings);
    this.api
      .post(
        '/profile',
        {
          name: this.userToUse.name,
          phone: this.userToUse.phone,
          dateFormat: userData ? userData.DateFormat : this.userToUse.date_format,
        },
        true
      )
      .subscribe(
        (result) => {
          if (!result.success) {
            that.messagebox.open({
              buttons: that.messagebox.buttons.Close,
              headerText: that.trans('general.titleError'),
              messageContent: result.error,
              iconType: that.messagebox.iconType.Error
            });
            that.revertChanges(old);
            return;
          }
          that.us.saveCurrentUser();
          if (that.platform.isAndroid()) {
            that.platform.androidHandler().setDateTimeFormat(that.us.currentUser.date_format);
          } else if (that.platform.isApple()) {
            that.platform.appleHandler().setDateTimeFormat.postMessage(that.us.currentUser.date_format);
          }
        },
        (error) => {
          that.revertChanges(old);
        }
      );

    return true;
  }

  private populateDateTimeFormats() {
    this.dateTimeFormats = [
      { value: 1, label: this.dt.formatDateTime(new Date(), false, 1) },
      { value: 2, label: this.dt.formatDateTime(new Date(), false, 2) },
      { value: 3, label: this.dt.formatDateTime(new Date(), false, 3) },
      { value: 4, label: this.dt.formatDateTime(new Date(), false, 4) },
    ];
  }

  private revertChanges(oldSettings: string) {
    if (this.us.currentUser.id === 0) {
      return;
    }
    const settings = JSON.parse(oldSettings);
    this.us.currentUser.name = settings.name;
    this.us.currentUser.phone = settings.phone;
    this.us.currentUser.date_format = settings.format;
    this.us.saveCurrentUser();
  }

  public goChangePass() {
    this.revertChanges(JSON.stringify(this.oldSettings));
    this.router.navigate(['/password-change']);
  }

  public goDeleteAccount() {
    this.revertChanges(JSON.stringify(this.oldSettings));
    this.router.navigate(['/profile/delete']);
  }

  public languageClick() {
    this.router.navigate(['/select-language']);
  }

  public doDownloadAccount() {
    if (this.miniStatus.isVisible()) {
      this.miniStatus.flash();
      return;
    }
    const that = this;
    this.miniStatus.show(this.trans('general.download.generating'));
    this.api.post('/download-account', {}, true).subscribe(
      (result) => {
        if (result.success) {
          that.getTheFile();
        } else {
          that.miniStatus.hide();
          that.messagebox.open({
            buttons: that.messagebox.buttons.Close,
            headerText: that.trans('general.titleError'),
            messageContent: result.error,
            iconType: that.messagebox.iconType.Error
          });
        }
      },
      (error) => {
        that.messagebox.open({
          buttons: that.messagebox.buttons.Close,
          headerText: that.trans('general.titleError'),
          messageContent: that.trans('auth.errors.serverSideError'),
          iconType: that.messagebox.iconType.Error
        });
        that.miniStatus.hide();
      }
    );
  }

  private getTheFile() {
    document.location.href = this.api.getBaseUrl() + '/download-account-file?u=' + this.api.getToken() + (this.platform.isAndroid() ? '&an=1' : '');
    if (this.platform.isDesktop()) {
      this.miniStatus.show(this.trans('general.download.started'));
      setTimeout(() => {
        this.miniStatus.hide();
      }, 2000);
    } else {
      this.miniStatus.hide();
    }
  }

  public getLangSubCode(): string {
    if (this.ls.selectedLanguage.value === null) {
      this.ls.selectedLanguage.value = 'en';
    }
    const minusPos = this.ls.selectedLanguage.value.lastIndexOf('-');
    const dashPos = this.ls.selectedLanguage.value.lastIndexOf('_');
    const lastPos = Math.max(minusPos, dashPos);
    const subCodePart = lastPos === -1 ? this.ls.selectedLanguage.value : this.ls.selectedLanguage.value.substr(lastPos + 1);
    return subCodePart.toUpperCase();
  }

  public changeDateFormat() {
    const that = this;
    this.pp.showSlideout<DropdownItem<number>>(
      {
        headerText: this.trans('users.labels.dateTimeFormat'),
        items: this.dateTimeFormats,
        onSubmit: (res) => {
          const fmt = that.dateTimeFormats.find((f) => f.value === res.value);
          that.dateFormatText = fmt.label as string;
          that.userToUse.date_format = fmt.value;
          that.userDataChanged = true;
        },
      },
      PopupType.SlideoutWithValue
    );
  }
}
